import LocationNotesDetailsWrapper from "@/pages/locaties/notes/LocationNoteDetailsWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/locaties/$locationId/notities/$noteThreadId/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "locations"),
})

function RouteComponent() {
  const { locationId, noteThreadId } = useParams({
    from: "/beheer/locaties/$locationId/notities/$noteThreadId/",
  })

  return (
    <LocationNotesDetailsWrapper
      locationId={Number(locationId)}
      noteThreadId={Number(noteThreadId)}
    />
  )
}
